import { get, isEmpty } from "lodash";
import { required } from "@vuelidate/validators";
import { requiredSin, withValidSin } from "@Shared/@Utils/validation-rules";
export const requiredValidationField = (selectedFlow, currentSchema) => {
  return {
    getRequiredValidation: (fieldName, isVisible, type = "") => {
      var _schemaObject$require;
      if (isEmpty(currentSchema == null ? void 0 : currentSchema.value)) return {};
      const schemaObject = get(currentSchema.value, `${fieldsMapPaths[fieldName]}`);
      if (!isVisible || !(schemaObject != null && (_schemaObject$require = schemaObject.required) != null && _schemaObject$require[selectedFlow.value])) return {};
      if (type === "address") return {
        line1: {
          required
        },
        "street-number": {
          required
        },
        "street-name": {
          required
        },
        city: {
          required
        },
        province: {
          required
        },
        "postal-code": {
          required
        },
        required
      };
      if (type === "sin") return {
        requiredSin,
        withValidSin
      };
      return {
        required
      };
    }
  };
};
export const fieldsMapPaths = {
  salutation: "[main-applicant][personal-details][salutation]",
  firstName: "[main-applicant][personal-details][first-name]",
  middleName: "[main-applicant][personal-details][middle-name]",
  lastName: "[main-applicant][personal-details][last-name]",
  email: "[main-applicant][personal-details][email]",
  phoneNumber: "[main-applicant][personal-details][phone-number]",
  altPhoneNumber: "[main-applicant][personal-details][alt-phone-number]",
  workPhone: "[main-applicant][personal-details][work-phone]",
  sin: "[main-applicant][personal-details][sin]",
  dateOfBirth: "[main-applicant][personal-details][date-of-birth]",
  numChildren: "[main-applicant][personal-details][num-children]",
  languagePreference: "[main-applicant][personal-details][language-preference]",
  own: "[main-applicant][personal-details][own]",
  monthlyRent: "[main-applicant][personal-details][monthly-rent]",
  employerName: "[main-applicant][employment][employer-name]",
  currentJob: "[main-applicant][employment][current-job]",
  companyType: "[main-applicant][employment][company-type]",
  employmentType: "[main-applicant][employment][employment-type]",
  grossRevenue: "[main-applicant][employment][gross-revenue]",
  incomeAmount: "[main-applicant][employment][income-amount]",
  incomePeriod: "[main-applicant][employment][income-period]",
  incomeType: "[main-applicant][employment][income-type]",
  industrySector: "[main-applicant][employment][industry-sector]",
  jobTitle: "[main-applicant][employment][job-title]",
  monthsInIndustry: "[main-applicant][employment][months-in-industry]",
  occupation: "[main-applicant][employment][occupation]",
  operatingAs: "[main-applicant][employment][operating-as]",
  selfEmployed: "[main-applicant][employment][self-employed]",
  timeAtJob: "[main-applicant][employment][time-at-job]",
  employmentWorkPhone: "[main-applicant][employment][work-phone]",
  employmentAddress: "[main-applicant][employment][address]",
  addresses: "[main-applicant][personal-details][addresses]",
  assetType: "[main-applicant][assets][type]",
  assetDescription: "[main-applicant][assets][description]",
  assetAmount: "[main-applicant][assets][amount]",
  otherPropertiesPurchasePrice: "[main-applicant][other-properties][property-details][purchase-price]",
  otherPropertiesEstimatedValue: "[main-applicant][other-properties][property-details][estimated-value]",
  otherPropertiesPurchaseDate: "[main-applicant][other-properties][property-details][purchase-date]",
  otherPropertiesAddress: "[main-applicant][other-properties][property-details][address]",
  otherPropertiesDetailsAddressProvince: "[main-applicant][other-properties][property-details][rental-income-options-percent]",
  otherPropertiesPropertyTaxes: "[main-applicant][other-properties][property-costs][property-taxes]",
  otherPropertiesHeating: "[main-applicant][other-properties][property-costs][heating]",
  otherPropertiesFeesIncludeHeat: "[main-applicant][other-properties][property-costs][fees-include-heat]",
  otherPropertiesIncludeInTds: "[main-applicant][other-properties][property-costs][include-in-tds]",
  otherPropertiesMaintenanceFees: "[main-applicant][other-properties][property-costs][maintenance-fees]",
  otherPropertiesHydro: "[main-applicant][other-properties][property-rental][hydro]",
  otherPropertiesInsurance: "[main-applicant][other-properties][property-rental][insurance]",
  otherPropertiesInterest: "[main-applicant][other-properties][property-rental][interest]",
  otherPropertiesManagement: "[main-applicant][other-properties][property-rental][management]",
  otherPropertiesMonthlyIncome: "[main-applicant][other-properties][property-rental][monthly-income]",
  otherPropertiesOccupancy: "[main-applicant][other-properties][property-rental][occupancy]",
  otherPropertiesOthers: "[main-applicant][other-properties][property-rental][others]",
  otherPropertiesRepairs: "[main-applicant][other-properties][property-rental][repairs]",
  otherPropertiesRentalIncomeOptions: "[main-applicant][other-properties][property-rental][rental-income-options]",
  otherPropertiesRentalIncomeOptionsPercent: "[main-applicant][other-properties][property-rental][rental-income-options-percent]",
  otherPropertiesPercOfTotalMaintFees: "[main-applicant][other-properties][property-costs][perc-of-total-maint-fees]",
  existingMortgageBalanceRemaining: "[main-applicant][other-properties][other-property-existing-mortgages][balance-remaining]",
  existingMortgageFrequency: "[main-applicant][other-properties][other-property-existing-mortgages][frequency]",
  existingMortgageInterestRate: "[main-applicant][other-properties][other-property-existing-mortgages][interest-rate]",
  existingMortgageLender: "[main-applicant][other-properties][other-property-existing-mortgages][lender]",
  existingMortgageLoanType: "[main-applicant][other-properties][other-property-existing-mortgages][loan-type]",
  existingMortgageMaturityDate: "[main-applicant][other-properties][other-property-existing-mortgages][maturity-date]",
  existingMortgageMortgageType: "[main-applicant][other-properties][other-property-existing-mortgages][mortgage-type]",
  existingMortgageOrigAmount: "[main-applicant][other-properties][other-property-existing-mortgages][orig-amount]",
  existingMortgagePaymentAmount: "[main-applicant][other-properties][other-property-existing-mortgages][payment-amount]",
  existingMortgagePayoff: "[main-applicant][other-properties][other-property-existing-mortgages][payoff]",
  existingMortgageRateType: "[main-applicant][other-properties][other-property-existing-mortgages][rate-type]",
  existingMortgageTermType: "[main-applicant][other-properties][other-property-existing-mortgages][term-type]",
  identificationType: "[main-applicant][identifications][type]",
  identificationCountry: "[main-applicant][identifications][country]",
  identificationNumber: "[main-applicant][identifications][number]",
  liabilityType: "[main-applicant][liabilities][type]",
  liabilityLimit: "[main-applicant][liabilities][limit]",
  liabilityBalance: "[main-applicant][liabilities][balance]",
  liabilityPayment: "[main-applicant][liabilities][payment]",
  liabilityMaturityDate: "[main-applicant][liabilities][maturity-date]",
  liabilityPayoff: "[main-applicant][liabilities][payoff]",
  liabilityDescription: "[main-applicant][liabilities][description]",
  additionalIncomeAmount: "[main-applicant][other-income][amount]",
  additionalIncomeDescription: "[main-applicant][other-income][description]",
  additionalIncomePeriod: "[main-applicant][other-income][income-period]",
  additionalIncomeType: "[main-applicant][other-income][type]",
  firstTimeHomeBuyer: "[main-applicant][personal-details][first-time-home-buyer]",
  maritalStatus: "[main-applicant][personal-details][marital-status]",
  mortgageDetailsClosingDate: "[mortgage-details][mortgage-details][closing-date]",
  mortgageDetailsDownpaymentAmount: "[mortgage-details][down-payment][amount]",
  propertyDetailsOccupancy: "[property][details][occupancy]",
  propertyDetailsPurchasePrice: "[property][details][purchase-price]",
  propertyAddress: "[property][details][address]",
  propertyDetailsPurchaseDate: "[property][details][purchase-date]",
  propertyDetailsLivingSpace: "[property][details][living-space]",
  propertyDetailsAppraisedValue: "[property][details][appraised-value]",
  propertyDetailsAppraisalDate: "[property][details][appraisal-date]",
  propertyDetailsBlock: "[property][details][block]",
  propertyDetailsConcTownship: "[property][details][conc-township]",
  propertyDetailsEstimatedValue: "[property][details][estimated-value]",
  propertyDetailsLot: "[property][details][lot]",
  propertyDetailsMlsListing: "[property][details][mls-listing]",
  propertyDetailsMonthlyIncome: "[property][details][monthly-income]",
  propertyDetailsPropertyValueIndex: "[property][details][property-value-index]",
  propertyDetailsRentalProperty: "[property][details][rental-property]",
  propertyDetailsAddressProvince: "[property][details][address]",
  propertyStylePropertyStyle: "[property][styles][property-style]",
  propertyStylePropertyType: "[property][styles][property-type]",
  propertyStyleGarageSize: "[property][styles][garage-size]",
  propertyStyleConstructionType: "[property][styles][construction-type]",
  propertyStyleEnvironmentalHazard: "[property][styles][environmental-hazard]",
  propertyStyleHeat: "[property][styles][heat]",
  propertyStyleLotSize: "[property][styles][lot-size]",
  propertyStyleGarageStyle: "[property][styles][garage-style]",
  propertyStyleLotSizeType: "[property][styles][lot-size-type]",
  propertyStyleNumberOfUnits: "[property][styles][number-of-units]",
  propertyStyleSewageInfo: "[property][styles][sewage-info]",
  propertyStyleStructureAge: "[property][styles][structure-age]",
  propertyStyleTenure: "[property][styles][tenure]",
  propertyStyleWaterInfo: "[property][styles][water-info]",
  propertyCostsFeesIncludeHeat: "[property][costs][fees-include-heat]",
  propertyCostsHeating: "[property][costs][heating]",
  propertyCostsHydro: "[property][costs][hydro]",
  propertyCostsIncludeInTds: "[property][costs][include-in-tds]",
  propertyCostsInsurance: "[property][costs][insurance]",
  propertyCostsInterest: "[property][costs][interest]",
  propertyCostsMaintenanceFees: "[property][costs][maintenance-fees]",
  propertyCostsManagement: "[property][costs][management]",
  propertyCostsOthers: "[property][costs][others]",
  propertyCostsPercOfTotalMaintFees: "[property][costs][perc-of-total-maint-fees]",
  propertyCostsPropertyTaxes: "[property][costs][property-taxes]",
  propertyCostsRentalIncomeOptions: "[property][costs][rental-income-options]",
  propertyCostsRentalIncomeOptionsPercent: "[property][costs][rental-income-options-percent]",
  propertyCostsRepairs: "[property][costs][repairs]",
  propertyCostsTaxResponsible: "[property][costs][tax-responsible]",
  propertyCostsTaxYear: "[property][costs][tax-year]",
  propertyExistingMortgageBalanceRemaining: "[property][existing-mortgages][balance-remaining]",
  propertyExistingMortgageBlendedAmortization: "[property][existing-mortgages][blended-amortization]",
  propertyExistingMortgageCurrentMortgageNumber: "[property][existing-mortgages][current-mortgage-number]",
  propertyExistingMortgageFrequency: "[property][existing-mortgages][frequency]",
  propertyExistingMortgageInsured: "[property][existing-mortgages][insured]",
  propertyExistingMortgageInterestRate: "[property][existing-mortgages][interest-rate]",
  propertyExistingMortgageLender: "[property][existing-mortgages][lender]",
  propertyExistingMortgageLoanType: "[property][existing-mortgages][loan-type]",
  propertyExistingMortgageMaturityDate: "[property][existing-mortgages][maturity-date]",
  propertyExistingMortgageMortgageInsuranceProviderId: "[property][existing-mortgages][mortgage-insurance-provider-id]",
  propertyExistingMortgageMortgageType: "[property][existing-mortgages][mortgage-type]",
  propertyExistingMortgageOrigAmount: "[property][existing-mortgages][orig-amount]",
  propertyExistingMortgagePaymentAmount: "[property][existing-mortgages][payment-amount]",
  propertyExistingMortgagePayoff: "[property][existing-mortgages][payoff]",
  propertyExistingMortgageRateType: "[property][existing-mortgages][rate-type]",
  propertyExistingMortgageRefiAdditionalInfo: "[property][existing-mortgages][refi-additional-info]",
  propertyExistingMortgageTermType: "[property][existing-mortgages][term-type]",
  propertyExistingMortgageInsuranceAccountNumber: "[property][existing-mortgages][insurance-account-number]",
  applicantSalutation: "[co-applicants][personal-details][salutation]",
  applicantFirstName: "[co-applicants][personal-details][first-name]",
  applicantMiddleName: "[co-applicants][personal-details][middle-name]",
  applicantLastName: "[co-applicants][personal-details][last-name]",
  applicantEmail: "[co-applicants][personal-details][email]",
  applicantPhoneNumber: "[co-applicants][personal-details][phone-number]",
  applicantAltPhoneNumber: "[co-applicants][personal-details][alt-phone-number]",
  applicantWorkPhone: "[co-applicants][personal-details][work-phone]",
  applicantSin: "[co-applicants][personal-details][sin]",
  applicantDateOfBirth: "[co-applicants][personal-details][date-of-birth]",
  applicantLanguagePreference: "[co-applicants][personal-details][language-preference]",
  applicantOwn: "[co-applicants][personal-details][own]",
  applicantMonthlyRent: "[co-applicants][personal-details][monthly-rent]",
  applicantCoApplicantType: "[co-applicants][personal-details][co-applicant-type]",
  applicantRelationshipToMainApplicant: "[co-applicants][personal-details][relationship-to-main-applicant]",
  applicantAddresses: "[co-applicants][personal-details][addresses]",
  applicantEmployerName: "[co-applicants][employment][employer-name]",
  applicantCurrentJob: "[co-applicants][employment][current-job]",
  applicantCompanyType: "[co-applicants][employment][company-type]",
  applicantEmploymentType: "[co-applicants][employment][employment-type]",
  applicantGrossRevenue: "[co-applicants][employment][gross-revenue]",
  applicantIncomeAmount: "[co-applicants][employment][income-amount]",
  applicantIncomePeriod: "[co-applicants][employment][income-period]",
  applicantIncomeType: "[co-applicants][employment][income-type]",
  applicantIndustrySector: "[co-applicants][employment][industry-sector]",
  applicantJobTitle: "[co-applicants][employment][job-title]",
  applicantMonthsInIndustry: "[co-applicants][employment][months-in-industry]",
  applicantOccupation: "[co-applicants][employment][occupation]",
  applicantOperatingAs: "[co-applicants][employment][operating-as]",
  applicantSelfEmployed: "[co-applicants][employment][self-employed]",
  applicantTimeAtJob: "[co-applicants][employment][time-at-job]",
  applicantEmploymentWorkPhone: "[co-applicants][employment][work-phone]",
  applicantEmploymentAddress: "[co-applicants][employment][address]",
  applicantAssetType: "[co-applicants][assets][type]",
  applicantAssetDescription: "[co-applicants][assets][description]",
  applicantAssetAmount: "[co-applicants][assets][amount]",
  applicantOtherPropertiesPurchasePrice: "[co-applicants][other-properties][property-details][purchase-price]",
  applicantOtherPropertiesEstimatedValue: "[co-applicants][other-properties][property-details][estimated-value]",
  applicantOtherPropertiesPurchaseDate: "[co-applicants][other-properties][property-details][purchase-date]",
  applicantOtherPropertiesAddress: "[co-applicants][other-properties][property-details][address]",
  applicantOtherPropertiesPropertyTaxes: "[co-applicants][other-properties][property-costs][property-taxes]",
  applicantOtherPropertiesHeating: "[co-applicants][other-properties][property-costs][heating]",
  applicantOtherPropertiesFeesIncludeHeat: "[co-applicants][other-properties][property-costs][fees-include-heat]",
  applicantOtherPropertiesIncludeInTds: "[co-applicants][other-properties][property-costs][include-in-tds]",
  applicantOtherPropertiesMaintenanceFees: "[co-applicants][other-properties][property-costs][maintenance-fees]",
  applicantOtherPropertiesHydro: "[co-applicants][other-properties][property-rental][hydro]",
  applicantOtherPropertiesInsurance: "[co-applicants][other-properties][property-rental][insurance]",
  applicantOtherPropertiesInterest: "[co-applicants][other-properties][property-rental][interest]",
  applicantOtherPropertiesManagement: "[co-applicants][other-properties][property-rental][management]",
  applicantOtherPropertiesMonthlyIncome: "[co-applicants][other-properties][property-rental][monthly-income]",
  applicantOtherPropertiesOccupancy: "[co-applicants][other-properties][property-rental][occupancy]",
  applicantOtherPropertiesOthers: "[co-applicants][other-properties][property-rental][others]",
  applicantOtherPropertiesRepairs: "[co-applicants][other-properties][property-rental][repairs]",
  applicantOtherPropertiesRentalIncomeOptions: "[co-applicants][other-properties][property-rental][rental-income-options]",
  applicantOtherPropertiesRentalIncomeOptionsPercent: "[co-applicants][other-properties][property-rental][rental-income-options-percent]",
  applicantOtherPropertiesPercOfTotalMaintFees: "[co-applicants][other-properties][property-costs][perc-of-total-maint-fees]",
  applicantExistingMortgageBalanceRemaining: "[co-applicants][other-properties][other-property-existing-mortgages][balance-remaining]",
  applicantExistingMortgageFrequency: "[co-applicants][other-properties][other-property-existing-mortgages][frequency]",
  applicantExistingMortgageInterestRate: "[co-applicants][other-properties][other-property-existing-mortgages][interest-rate]",
  applicantExistingMortgageLender: "[co-applicants][other-properties][other-property-existing-mortgages][lender]",
  applicantExistingMortgageLoanType: "[co-applicants][other-properties][other-property-existing-mortgages][loan-type]",
  applicantExistingMortgageMaturityDate: "[co-applicants][other-properties][other-property-existing-mortgages][maturity-date]",
  applicantExistingMortgageMortgageType: "[co-applicants][other-properties][other-property-existing-mortgages][mortgage-type]",
  applicantExistingMortgageOrigAmount: "[co-applicants][other-properties][other-property-existing-mortgages][orig-amount]",
  applicantExistingMortgagePaymentAmount: "[co-applicants][other-properties][other-property-existing-mortgages][payment-amount]",
  applicantExistingMortgagePayoff: "[co-applicants][other-properties][other-property-existing-mortgages][payoff]",
  applicantExistingMortgageRateType: "[co-applicants][other-properties][other-property-existing-mortgages][rate-type]",
  applicantExistingMortgageTermType: "[co-applicants][other-properties][other-property-existing-mortgages][term-type]",
  applicantIdentificationType: "[co-applicants][identifications][type]",
  applicantIdentificationCountry: "[co-applicants][identifications][country]",
  applicantIdentificationNumber: "[co-applicants][identifications][number]",
  applicantLiabilityType: "[co-applicants][liabilities][type]",
  applicantLiabilityLimit: "[co-applicants][liabilities][limit]",
  applicantLiabilityBalance: "[co-applicants][liabilities][balance]",
  applicantLiabilityPayment: "[co-applicants][liabilities][payment]",
  applicantLiabilityMaturityDate: "[co-applicants][liabilities][maturity-date]",
  applicantLiabilityPayoff: "[co-applicants][liabilities][payoff]",
  applicantLiabilityDescription: "[co-applicants][liabilities][description]",
  applicantAdditionalIncomeAmount: "[co-applicants][other-income][amount]",
  applicantAdditionalIncomeDescription: "[co-applicants][other-income][description]",
  applicantAdditionalIncomeIncomePeriod: "[co-applicants][other-income][income-period]",
  applicantAdditionalIncomeType: "[co-applicants][other-income][type]",
  applicantFirstTimeHomeBuyer: "[co-applicants][personal-details][first-time-home-buyer]",
  applicantMaritalStatus: "[co-applicants][personal-details][marital-status]"
};